import { Table } from "antd";
import {
  TICKET_TABLE_WIDTHS,
  getResponsiveWidth,
} from "../../../../../constants/tableWidths";

const TicketsExpandableRow = (record, groupCurrency) => {
  const columns = [
    {
      title: "Action",
      width: TICKET_TABLE_WIDTHS.ACTION,
      className: "header-white",
      render: () => {
        return <></>;
      },
      align: "center",
    },
    {
      title: "Status",
      width: TICKET_TABLE_WIDTHS.STATUS,
      className: "header-white",
      key: "status",
      dataIndex: "status",
      align: "center",
      render: (status) => {
        if (status === "live") {
          return <span>Live</span>;
        }
        if (status === "saved") {
          return <span>Saved</span>;
        }
        if (status === "archived") {
          return <span>Archived</span>;
        }
        if (status === "sale-ended") {
          return <span>Sale Ended</span>;
        }
        return <span></span>;
      },
    },
    {
      title: "Web",
      width: TICKET_TABLE_WIDTHS.WEB,
      className: "header-white",
      key: "link",
      align: "center",
    },
    {
      title: "Match",
      width: getResponsiveWidth(TICKET_TABLE_WIDTHS.MATCH),
      key: "matchName",
      // fixed: window.screen.width > 500 ? "left" : false,
      className: "header-white",
      dataIndex: "matchName",
      align: "center",
    },
    {
      title: "Type",
      width: getResponsiveWidth(TICKET_TABLE_WIDTHS.TYPE),
      key: "ticketType",
      dataIndex: "ticketType",
      className: "header-white",
      align: "center",
    },
    {
      title: window.screen.width > 500 ? "Event Name" : "Name",
      width: TICKET_TABLE_WIDTHS.EVENT_NAME,
      key: "eventName",
      className: "header-white",
      dataIndex: "eventName",
      align: "center",
    },
    {
      title: "Revenue",
      width: getResponsiveWidth(TICKET_TABLE_WIDTHS.REVENUE),
      key: "revenue",
      dataIndex: "revenue",
      className: "header-white",
      align: "center",
      render: (data) => {
        let dataAsFloat = parseFloat((data || "0").toString());
        let dataAsString = dataAsFloat.toFixed(
          Math.round(dataAsFloat) === dataAsFloat ? 0 : 2
        );
        return <span>{data ? `${groupCurrency}${dataAsString}` : "-"}</span>;
      },
    },
    {
      title: (
        <div style={{ textAlign: "center" }}>
          <p style={{ fontSize: "18px" }}>Quantity</p>
          <p style={{ fontSize: "12px" }}>Total/Sold/Avail</p>
        </div>
      ),
      width: getResponsiveWidth(TICKET_TABLE_WIDTHS.QUANTITY),
      key: "quanity",
      dataIndex: "quantity",
      align: "center",
    },
    {
      title: "Checkins",
      width: getResponsiveWidth(TICKET_TABLE_WIDTHS.CHECKINS),
      key: "checkins",
      dataIndex: "checkins",
      align: "center",
    },
    {
      title: (
        <div style={{ textAlign: "center" }}>
          <p style={{ fontSize: "18px" }}>Price</p>
          <p style={{ fontSize: "12px" }}>Member/Non-Member</p>
        </div>
      ),
      width: TICKET_TABLE_WIDTHS.PRICE,
      key: "price",
      dataIndex: "price",
      align: "center",
    },

    {
      title: window.screen.width > 500 ? "Limit / Person?" : "Limit",
      // width: 100,
      key: "ticketLimitPerMember",
      className: "header-white",
      dataIndex: "ticketLimitPerMember",
      align: "center",
    },

    {
      title: window.screen.width > 500 ? "Event Date" : "Date",
      width: TICKET_TABLE_WIDTHS.EVENT_DATE,
      key: "groupTicket",
      className: "header-white",
      render: () => <></>,
      align: "center",
    },
    {
      title: "Sale End Date",
      width: getResponsiveWidth(TICKET_TABLE_WIDTHS.SALE_END_DATE),
      key: "saleEndDate",
      align: "center",
    },
    {
      title: window.screen.width > 500 ? "Event Code" : "Code",
      width: TICKET_TABLE_WIDTHS.EVENT_CODE,
      key: "groupTicket.eventCode",
      className: "header-white",
      align: "center",
    },
  ];

  const nestedTable = record?.groupTicket?.tickets?.map((item) => {
    return {
      showForFans: true,
      link: "",
      ticketType: item.matchTicket,
      eventName: item.name,
      revenue: item.revenue,
      quantity: `${item.quantity} / ${item.soldTickets} / ${
        item.quantity - item.soldTickets
      }`,
      checkins: item.noOfCheckins,
      price: `${item.memberPrice ? `${groupCurrency}${item.memberPrice}` : "-"} / ${item.nonMemberPrice ? `${groupCurrency}${item.nonMemberPrice}` : "-"}`,
      ticketLimitPerMember: item.limitPerPerson,
    };
  });

  return (
    <Table
      showHeader={false}
      columns={columns}
      dataSource={nestedTable}
      pagination={false}
      bodyStyle={{
        fontSize: window.screen.width > 500 ? "18px" : "12px",
      }}
    />
  );
};

export default TicketsExpandableRow;
